import React, { useEffect, useState } from 'react';
import { orderList } from '@/apis/order';
import { debounce } from 'lodash';
import dayjs from 'dayjs';
import './styles.scss';

const RecordScroll = ({ userInfo }) => {
  const [records, setRecords] = useState<any[]>([]);
  const [page, setPage] = useState('');
  const [hasMore, setHasMore] = useState(true);


  useEffect(() => {
    fetchRecords(page);
  }, []);

  const fetchRecords = async (pageNum) => {
    if (!userInfo?.user_id) return;
    const res = await orderList({ cursor: pageNum, limit: 5 });

    if (res?.list?.length <= 5 && !res?.has_next) {
      setHasMore(false);
    }
    setPage(res.next_cursor);
    setRecords((prev) => [...prev, ...res.list]);
  };
  
  const handleScroll = debounce((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore) {
        //   setPage((prev) => prev + 1);
        fetchRecords(page);
    }
  }, 500);

  return (
    <div className="record-container" onScroll={handleScroll}>
        <div className="record-list">
        {records.map((record, index) => (
            <div className="record-item" key={index}>
                <div className="record-item-head">
                <div className="record-item-name">
                    {record?.title}
                </div>
                </div>
                <div className="record-item-desc">
                  {
                    record?.title
                      ? (
                        <div className="desc-item">
                          <div className="desc-item-left">
                          订阅类型
                          </div>
                          <div className="desc-item-right">
                          {record?.title}
                          </div>
                        </div>
                      )
                      : null 
                  }
                
                <div className="desc-item">
                    <div className="desc-item-left">
                    价格
                    </div>
                    <div className="desc-item-right">
                    {Number(record?.amount / 100).toFixed(2)}元
                    </div>
                </div>
                <div className="desc-item">
                    <div className="desc-item-left">
                    购买时间
                    </div>
                    <div className="desc-item-right">
                    {dayjs(record?.paid_time).format("YYYY-MM-DD-HH:mm")}
                    </div>
                </div>
                <div className="desc-item">
                    <div className="desc-item-left">
                    订单编号
                    </div>
                    <div className="desc-item-right">
                    {record?.order_num}
                    </div>
                </div>
                <div className="desc-item">
                    <div className="desc-item-left">
                    支付方式
                    </div>
                    <div className="desc-item-right">
                    {record?.paid_type}
                    </div>
                </div>
                </div>
            </div>
        ))}
        {hasMore && <div className="no-more-records">加载更多</div>}
        {!hasMore && <div className="no-more-records">没有更多记录了</div>}
        </div>
    </div>
  );
};

export default RecordScroll;